import { Button } from "@chakra-ui/react"
import { useTranslate } from "../lng/withTranslate"
import Pathicon from "../pathicon/Pathicon"
import { EmptyState, EmptyStateProps } from "./EmptyState"

export type SearchEmptyStateProps = {
  onClearSearch: () => void
} & Omit<EmptyStateProps, "title" | "description" | "icon">

function SearchEmptyState({ onClearSearch, ...props }: SearchEmptyStateProps) {
  const { t } = useTranslate()

  return (
    <EmptyState
      title={t("search_empty.title", "No results found")}
      description={t("search_empty.description", "Try a different search.")}
      size="lg"
      {...props}
    >
      <Button onClick={onClearSearch}>
        <Pathicon icon="x" />
        <>{t("search_empty.button", "Clear search")}</>
      </Button>
    </EmptyState>
  )
}

export default SearchEmptyState
